import type { ISerialize } from '@/objects/ISerialize';
import { GPIOReading } from './GPIOReading';

export class AttachGPIOReadingToRequest implements ISerialize {
    public CategoryIDs: number[];

    public GroupIDs: number[];

    public Reading: GPIOReading | null;

    public UpdateContestantsStartTime: boolean;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        CategoryIDs?: number[];
        GroupIDs?: number[];
        Reading?: GPIOReading | null;
        UpdateContestantsStartTime?: boolean;
    }) {
        this.CategoryIDs = values.CategoryIDs ?? [];

        this.GroupIDs = values.GroupIDs ?? [];

        this.Reading = values.Reading ?? null;

        this.UpdateContestantsStartTime = values.UpdateContestantsStartTime ?? false;
    }

    public serialize(): string {
        return (
            '{' +
            `"CategoryIDs": [ ${this.CategoryIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"GroupIDs": [ ${this.GroupIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"Reading": ${!this.Reading ? null : this.Reading?.serialize()}` +
            ',' +
            `"UpdateContestantsStartTime": ${JSON.stringify(this.UpdateContestantsStartTime)}` +
            '}'
        );
    }

    /**
     * Creates an instance of AttachGPIOReadingToRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        CategoryIDs?: number[];
        GroupIDs?: number[];
        Reading?: GPIOReading | null;
        UpdateContestantsStartTime?: boolean;
    }): AttachGPIOReadingToRequest {
        return new AttachGPIOReadingToRequest(values);
    }

    public static _FromServerJson(json: any): AttachGPIOReadingToRequest {
        return new AttachGPIOReadingToRequest({
            CategoryIDs: json.CategoryIDs,
            GroupIDs: json.GroupIDs,
            Reading: json.Reading ? GPIOReading._FromServerJson(json.Reading) : null,
            UpdateContestantsStartTime: json.UpdateContestantsStartTime,
        });
    }

    /**
     * Creates an instance of AttachGPIOReadingToRequest from another instance of AttachGPIOReadingToRequest.
     * @param other The AttachGPIOReadingToRequest you want to clone
     * @returns A cloned AttachGPIOReadingToRequest
     */
    public static FromOther(other: AttachGPIOReadingToRequest): AttachGPIOReadingToRequest {
        return AttachGPIOReadingToRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return AttachGPIOReadingToRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'AttachGPIOReadingToRequest';
}
